// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2621":"f073fc9a","7964":"60e95bcc","8017":"94e3a415","9493":"94e3a415"}[chunkId] + ".css";
};